import React, { useEffect, createElement } from 'react';
import { CheckCircleIcon, AlertTriangleIcon, BotIcon, LightbulbIcon, SmartphoneIcon, RocketIcon, ZapIcon, CalendarIcon, PhoneIcon, MapPinIcon, PenLineIcon, MailIcon, QuoteIcon, StarIcon } from 'lucide-react';
import { Footer } from '../components/Footer';
import { WhatsAppButton } from '../components/WhatsAppButton';
declare global {
  interface Window {
    fbq: any;
  }
}
export function LlamadaConfirmationPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
    (function (f: any, b: any, e: any, v: any, n: any, t: any, s: any) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      if (s && s.parentNode) {
        s.parentNode.insertBefore(t, s);
      } else {
        b.head.appendChild(t);
      }
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js', null, null, null);
    // Pixel base + init handled globally in App.tsx — fire only this page's
    // unique Schedule conversion to avoid double-counting.
    if (window.fbq) {
      window.fbq('track', 'Schedule');
    }
  }, []);
  return <div className="min-h-screen bg-black text-white font-sans overflow-x-hidden" data-id="element-3123" data-mp="1qnqzhsu8ez00">
      {/* Meta Pixel Noscript */}
      <noscript data-id="element-3124" data-mp="1vl9bjs3jpuc8">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=754551913878347&ev=Schedule&noscript=1" alt="" data-id="element-3125" data-mp="1vkr6q72ti7sp" />
      </noscript>

      {/* HERO BANNER */}
      <div className="bg-gradient-to-r from-[#00f7fc]/20 to-[#00d7dc]/10 border-b border-[#00f7fc]/30 py-10 md:py-16 px-4" data-id="element-3126" data-mp="24mgyje0m38r0">
        <div className="max-w-3xl mx-auto text-center" data-id="element-3127" data-mp="69qpf9fblkbi">
          <div className="flex justify-center mb-5" data-id="element-3128" data-mp="aa0xcrmoakt0">
            <div className="w-20 h-20 bg-[#00f7fc]/10 border-2 border-[#00f7fc] rounded-full flex items-center justify-center" data-id="element-3129" data-mp="1djviwm6wgqaf">
              <CheckCircleIcon className="w-10 h-10 text-[#00f7fc]" data-id="element-3130" data-mp="18llmy9dcplnr" />
            </div>
          </div>
          <h1 className="text-3xl md:text-4xl lg:text-5xl font-black uppercase leading-tight tracking-tight mb-4" data-id="element-3131" data-mp="1mktlr15lqrrf">
            Tu Llamada Está <span className="text-[#00f7fc]" data-id="element-3132" data-mp="1iholz6cwp46h">Confirmada</span>
          </h1>
          <p className="text-base md:text-lg text-gray-300 flex items-center justify-center gap-2" data-id="element-3133" data-mp="1whpoeq8tkjo2">
            <MailIcon className="w-5 h-5 text-[#00f7fc] flex-shrink-0" data-id="element-3134" data-mp="1rimplnjfn9oj" />
            Revisa tu email para los detalles de conexión
          </p>
        </div>
      </div>

      <main className="max-w-4xl mx-auto px-4 py-10 md:py-16 space-y-12 md:space-y-16" data-id="element-3135" data-mp="219ppim0mlim8">
        {/* IMPORTANT WARNING */}
        <section data-id="element-3136" data-mp="2faaczvhhk2m2">
          <div className="bg-yellow-500/10 border-2 border-yellow-500/40 rounded-2xl p-6 md:p-8" data-id="element-3137" data-mp="2f9s684x765zw">
            <div className="flex items-start gap-4" data-id="element-3138" data-mp="2abqopoff6eqj">
              <div className="flex-shrink-0 w-10 h-10 bg-yellow-500/20 rounded-full flex items-center justify-center" data-id="element-3139" data-mp="2tw7gile8ag1n">
                <AlertTriangleIcon className="w-5 h-5 text-yellow-400" data-id="element-3140" data-mp="2yvah9tn6e03t" />
              </div>
              <div data-id="element-3141" data-mp="2kw14l3y6ho4l">
                <h2 className="text-lg md:text-xl font-black uppercase tracking-wide text-yellow-400 mb-2" data-id="element-3142" data-mp="2kuhobdcivd2t">
                  IMPORTANTE: Lee Esto Antes de Cerrar Esta Página
                </h2>
                <p className="text-gray-200 text-base md:text-lg leading-relaxed" data-id="element-3143" data-mp="2b4ob67wqepwg">
                  Estás A <span className="font-black text-white" data-id="element-3144" data-mp="2fx7znzwyj5g1">UN PASO</span>{' '}
                  de Descubrir El Sistema de IA Que Está Cambiando Negocios en
                  Miami
                </p>
                <p className="text-gray-400 mt-3 text-sm md:text-base leading-relaxed" data-id="element-3145" data-mp="267eoh00q8scb">
                  En tu llamada, te mostraremos exactamente cómo usar
                  herramientas de inteligencia artificial para construir un
                  negocio digital real, desde cero, sin experiencia previa.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* WHAT WILL HAPPEN ON YOUR CALL */}
        <section data-id="element-3146" data-mp="1k88pec8e73n7">
          <div className="text-center mb-8" data-id="element-3147" data-mp="1fexrx1pgzz7y">
            <div className="inline-flex items-center gap-2 bg-[#00f7fc]/10 border border-[#00f7fc]/30 rounded-full px-4 py-2 mb-4" data-id="element-3148" data-mp="1fdv08rkbpsqz">
              <CheckCircleIcon className="w-4 h-4 text-[#00f7fc]" data-id="element-3149" data-mp="1bbroe1tqsm56" />
              <span className="text-sm font-semibold text-[#00f7fc] uppercase tracking-wide" data-id="element-3150" data-mp="16g2lppmfep4n">
                Lo Que Va a Pasar En Tu Llamada
              </span>
            </div>
          </div>

          <div className="grid md:grid-cols-2 gap-4" data-id="element-3151" data-mp="wh3bi2m0ilfj">
            <div className="bg-gray-900/60 border border-gray-800 rounded-xl p-5 flex items-start gap-4" data-id="element-3152" data-mp="sezvr1sb8uog">
              <div className="flex-shrink-0 w-10 h-10 bg-[#00f7fc]/10 rounded-lg flex items-center justify-center" data-id="element-3153" data-mp="2quusjn6o87l0">
                <BotIcon className="w-5 h-5 text-[#00f7fc]" data-id="element-3154" data-mp="2mshkgs4gbxl2" />
              </div>
              <p className="text-gray-200 text-sm md:text-base leading-relaxed" data-id="element-3155" data-mp="8li46ufbjich">
                Te mostraremos el sistema exacto de{' '}
                <span className="font-bold text-white" data-id="element-3156" data-mp="dii9v489aj32">
                  48 Horas AI Cash Machine
                </span>
              </p>
            </div>

            <div className="bg-gray-900/60 border border-gray-800 rounded-xl p-5 flex items-start gap-4" data-id="element-3157" data-mp="mc506etp2u4v">
              <div className="flex-shrink-0 w-10 h-10 bg-[#00f7fc]/10 rounded-lg flex items-center justify-center" data-id="element-3158" data-mp="3ls1nceqoyikj">
                <LightbulbIcon className="w-5 h-5 text-[#00f7fc]" data-id="element-3159" data-mp="3qrmmoq9rwsxs" />
              </div>
              <p className="text-gray-200 text-sm md:text-base leading-relaxed" data-id="element-3160" data-mp="3urx4r1aub9t0">
                Aprenderás cómo la IA puede{' '}
                <span className="font-bold text-white" data-id="element-3161" data-mp="3ngjk528vayw">
                  transformar tu negocio
                </span>{' '}
                desde hoy
              </p>
            </div>

            <div className="bg-gray-900/60 border border-gray-800 rounded-xl p-5 flex items-start gap-4" data-id="element-3162" data-mp="1ezr4jpaqy2ss">
              <div className="flex-shrink-0 w-10 h-10 bg-[#00f7fc]/10 rounded-lg flex items-center justify-center" data-id="element-3163" data-mp="3b2m41bt941uh">
                <SmartphoneIcon className="w-5 h-5 text-[#00f7fc]" data-id="element-3164" data-mp="372bw3tlwf1cz" />
              </div>
              <p className="text-gray-200 text-sm md:text-base leading-relaxed" data-id="element-3165" data-mp="3l1uwg08gx8eq">
                Todo desde tu{' '}
                <span className="font-bold text-white" data-id="element-3166" data-mp="3g1749b8i6lix">celular o laptop</span>,
                sin oficina ni empleados
              </p>
            </div>

            <div className="bg-gray-900/60 border border-gray-800 rounded-xl p-5 flex items-start gap-4" data-id="element-3167" data-mp="2nfnr2o4cbc1b">
              <div className="flex-shrink-0 w-10 h-10 bg-[#00f7fc]/10 rounded-lg flex items-center justify-center" data-id="element-3168" data-mp="324k4z1t2vj9u">
                <RocketIcon className="w-5 h-5 text-[#00f7fc]" data-id="element-3169" data-mp="2xb7ndbmtgcql" />
              </div>
              <p className="text-gray-200 text-sm md:text-base leading-relaxed" data-id="element-3170" data-mp="29lwra7gev6is">
                <span className="font-bold text-white" data-id="element-3171" data-mp="24owjns3wxvpk">
                  Sin experiencia técnica
                </span>{' '}
                requerida
              </p>
            </div>

            <div className="bg-gray-900/60 border border-gray-800 rounded-xl p-5 flex items-start gap-4 md:col-span-2" data-id="element-3172" data-mp="oxc87jebgklq">
              <div className="flex-shrink-0 w-10 h-10 bg-[#00f7fc]/10 rounded-lg flex items-center justify-center" data-id="element-3173" data-mp="b6ffztoay5f7">
                <ZapIcon className="w-5 h-5 text-[#00f7fc]" data-id="element-3174" data-mp="f7ivgf2ftzfw" />
              </div>
              <p className="text-gray-200 text-sm md:text-base leading-relaxed" data-id="element-3175" data-mp="12xn1su70gdal">
                Un sistema diseñado para{' '}
                <span className="font-bold text-white" data-id="element-3176" data-mp="17uvieqcig99q">
                  implementarse rápidamente
                </span>
              </p>
            </div>
          </div>
        </section>

        {/* BEFORE YOUR CALL - STEPS */}
        <section data-id="element-3177" data-mp="3em4gejln0o6k">
          <div className="bg-gray-900/50 border border-gray-800 rounded-2xl p-6 md:p-10" data-id="element-3178" data-mp="3ell87ulshe5q">
            <div className="flex items-center gap-3 mb-8" data-id="element-3179" data-mp="3jkxrk5dgc33k">
              <div className="w-8 h-8 bg-[#00f7fc]/10 rounded-full flex items-center justify-center flex-shrink-0" data-id="element-3180" data-mp="3jmimvx7lbq2h">
                <AlertTriangleIcon className="w-4 h-4 text-[#00f7fc]" data-id="element-3181" data-mp="e3k6k0loh62d" />
              </div>
              <h2 className="text-xl md:text-2xl font-black uppercase tracking-tight" data-id="element-3182" data-mp="a6e89vak7tix">
                Antes de Tu Llamada, Haz Esto{' '}
                <span className="text-[#00f7fc]" data-id="element-3183" data-mp="6niu80uw4pp">Ahora</span>
              </h2>
            </div>

            <div className="space-y-5" data-id="element-3184" data-mp="xudz0v7vfjxi">
              {/* Step 1 */}
              <div className="flex items-start gap-4" data-id="element-3185" data-mp="xvp6p64ftbtw">
                <div className="flex-shrink-0 w-10 h-10 bg-[#00f7fc] rounded-full flex items-center justify-center" data-id="element-3186" data-mp="sw42ag6i0b9s">
                  <CalendarIcon className="w-5 h-5 text-black" data-id="element-3187" data-mp="o28bbxonjoo4" />
                </div>
                <div data-id="element-3188" data-mp="j4gjf3o0c2jx">
                  <p className="font-black text-white text-base md:text-lg" data-id="element-3189" data-mp="j2vmx8i4u9jf">
                    Paso 1
                  </p>
                  <p className="text-gray-300 text-sm md:text-base" data-id="element-3190" data-mp="1btx8psgbz3bx">
                    Marca la fecha y hora en tu calendario ahora mismo
                  </p>
                </div>
              </div>

              {/* Step 2 */}
              <div className="flex items-start gap-4" data-id="element-3191" data-mp="1o4xw6wqt3fa8">
                <div className="flex-shrink-0 w-10 h-10 bg-[#00f7fc] rounded-full flex items-center justify-center" data-id="element-3192" data-mp="1t2zfnis59gm8">
                  <PhoneIcon className="w-5 h-5 text-black" data-id="element-3193" data-mp="1y2lt9tbvwyvk" />
                </div>
                <div data-id="element-3194" data-mp="223nu2elg9izn">
                  <p className="font-black text-white text-base md:text-lg" data-id="element-3195" data-mp="2247blu76u5d5">
                    Paso 2
                  </p>
                  <p className="text-gray-300 text-sm md:text-base" data-id="element-3196" data-mp="271fw41ft6lhk">
                    Guarda este número en tu teléfono para no perder la llamada
                  </p>
                </div>
              </div>

              {/* Step 3 */}
              <div className="flex items-start gap-4" data-id="element-3197" data-mp="2gueq5yu2r48k">
                <div className="flex-shrink-0 w-10 h-10 bg-[#00f7fc] rounded-full flex items-center justify-center" data-id="element-3198" data-mp="2lsy8lp9glxw6">
                  <MapPinIcon className="w-5 h-5 text-black" data-id="element-3199" data-mp="2pti5crq4ezhs" />
                </div>
                <div data-id="element-3200" data-mp="e0m6a47uqwh6">
                  <p className="font-black text-white text-base md:text-lg" data-id="element-3201" data-mp="dx816o7t0961">
                    Paso 3
                  </p>
                  <p className="text-gray-300 text-sm md:text-base" data-id="element-3202" data-mp="nxqsg41p6rxz">
                    Busca un lugar tranquilo sin distracciones para la llamada
                  </p>
                </div>
              </div>

              {/* Step 4 */}
              <div className="flex items-start gap-4" data-id="element-3203" data-mp="xmiexwnzok1i">
                <div className="flex-shrink-0 w-10 h-10 bg-[#00f7fc] rounded-full flex items-center justify-center" data-id="element-3204" data-mp="11ovnesu4ew1z">
                  <PenLineIcon className="w-5 h-5 text-black" data-id="element-3205" data-mp="16ngoeuh75jrh" />
                </div>
                <div data-id="element-3206" data-mp="1bmt8j7goocqd">
                  <p className="font-black text-white text-base md:text-lg" data-id="element-3207" data-mp="1bnbdqtlbq1af">
                    Paso 4
                  </p>
                  <p className="text-gray-300 text-sm md:text-base" data-id="element-3208" data-mp="38gwe9p5gmule">
                    Ten papel y lápiz listo para tomar notas importantes
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* TESTIMONIALS */}
        <section data-id="element-3209" data-mp="3135he3u410ci">
          <div className="text-center mb-8" data-id="element-3210" data-mp="312lyajsq45ww">
            <div className="inline-flex items-center gap-2 bg-[#00f7fc]/10 border border-[#00f7fc]/30 rounded-full px-4 py-2 mb-4" data-id="element-3211" data-mp="2w4u9hyndkzwx">
              <QuoteIcon className="w-4 h-4 text-[#00f7fc]" data-id="element-3212" data-mp="2r72ayls86fjr" />
              <span className="text-sm font-semibold text-[#00f7fc] uppercase tracking-wide" data-id="element-3213" data-mp="3othppft9oz3m">
                Lo Que Dicen Nuestros Estudiantes
              </span>
            </div>
          </div>

          <div className="grid md:grid-cols-3 gap-5" data-id="element-3214" data-mp="3evbol0fabwzt">
            {/* Testimonial 1 */}
            <div className="bg-gray-900/60 border border-gray-800 rounded-xl p-6 flex flex-col" data-id="element-3215" data-mp="39wim031jdqef">
              <div className="flex gap-1 mb-4" data-id="element-3216" data-mp="23gexlkzjixpt">
                <StarIcon className="w-4 h-4 text-[#FDB931] fill-[#FDB931]" data-id="element-3217" data-mp="23h7vrxkfoewc" />
                <StarIcon className="w-4 h-4 text-[#FDB931] fill-[#FDB931]" data-id="element-3218" data-mp="1ygtvj1p2q98v" />
                <StarIcon className="w-4 h-4 text-[#FDB931] fill-[#FDB931]" data-id="element-3219" data-mp="qhwiek6vyvnm" />
                <StarIcon className="w-4 h-4 text-[#FDB931] fill-[#FDB931]" data-id="element-3220" data-mp="qfs5jcr0emb7" />
                <StarIcon className="w-4 h-4 text-[#FDB931] fill-[#FDB931]" data-id="element-3221" data-mp="uiycynpuyjj9" />
              </div>
              <QuoteIcon className="w-6 h-6 text-[#00f7fc]/40 mb-3" data-id="element-3222" data-mp="gj704qb2v96u" />
              <p className="text-gray-300 text-sm leading-relaxed flex-1" data-id="element-3223" data-mp="li0fko9xda9n">
                "El sistema es claro, paso a paso y fácil de implementar. Me
                ayudó a entender cómo usar la IA en mi negocio de una manera que
                nunca había pensado."
              </p>
              <div className="mt-4 pt-4 border-t border-gray-800" data-id="element-3224" data-mp="3tz4zv2xpbtht">
                <p className="font-bold text-white text-sm" data-id="element-3225" data-mp="3twsaw5tj0iv9">Carlos M.</p>
                <p className="text-gray-500 text-xs" data-id="element-3226" data-mp="2stx92d1mkod">Miami, FL</p>
              </div>
            </div>

            {/* Testimonial 2 */}
            <div className="bg-gray-900/60 border border-gray-800 rounded-xl p-6 flex flex-col" data-id="element-3227" data-mp="3ozilgq65077f">
              <div className="flex gap-1 mb-4" data-id="element-3228" data-mp="35dqktez107yc">
                <StarIcon className="w-4 h-4 text-[#FDB931] fill-[#FDB931]" data-id="element-3229" data-mp="35ei5vvuzynad" />
                <StarIcon className="w-4 h-4 text-[#FDB931] fill-[#FDB931]" data-id="element-3230" data-mp="31cwxamphwv5z" />
                <StarIcon className="w-4 h-4 text-[#FDB931] fill-[#FDB931]" data-id="element-3231" data-mp="3fbmu018ekstt" />
                <StarIcon className="w-4 h-4 text-[#FDB931] fill-[#FDB931]" data-id="element-3232" data-mp="3f9jtgn9mjhau" />
                <StarIcon className="w-4 h-4 text-[#FDB931] fill-[#FDB931]" data-id="element-3233" data-mp="3abia018adfyu" />
              </div>
              <QuoteIcon className="w-6 h-6 text-[#00f7fc]/40 mb-3" data-id="element-3234" data-mp="3ob1emk1w296e" />
              <p className="text-gray-300 text-sm leading-relaxed flex-1" data-id="element-3235" data-mp="3k9y2o8myoxag">
                "Lo que más me gustó fue lo práctico que es. No es teoría, es
                acción inmediata desde el primer día."
              </p>
              <div className="mt-4 pt-4 border-t border-gray-800" data-id="element-3236" data-mp="3t3umhgsnlxmp">
                <p className="font-bold text-white text-sm" data-id="element-3237" data-mp="buefnrcvwb3u">Maria G.</p>
                <p className="text-gray-500 text-xs" data-id="element-3238" data-mp="6w30r27qfaer">Hialeah, FL</p>
              </div>
            </div>

            {/* Testimonial 3 */}
            <div className="bg-gray-900/60 border border-gray-800 rounded-xl p-6 flex flex-col" data-id="element-3239" data-mp="20ds8fopu30yb">
              <div className="flex gap-1 mb-4" data-id="element-3240" data-mp="25cv8euqyigzf">
                <StarIcon className="w-4 h-4 text-[#FDB931] fill-[#FDB931]" data-id="element-3241" data-mp="25bk50w1fbb8u" />
                <StarIcon className="w-4 h-4 text-[#FDB931] fill-[#FDB931]" data-id="element-3242" data-mp="2a5es89g8m8co" />
                <StarIcon className="w-4 h-4 text-[#FDB931] fill-[#FDB931]" data-id="element-3243" data-mp="2f2era0eo6aua" />
                <StarIcon className="w-4 h-4 text-[#FDB931] fill-[#FDB931]" data-id="element-3244" data-mp="1hgr5e9fubax0" />
                <StarIcon className="w-4 h-4 text-[#FDB931] fill-[#FDB931]" data-id="element-3245" data-mp="1meskyke24s3q" />
              </div>
              <QuoteIcon className="w-6 h-6 text-[#00f7fc]/40 mb-3" data-id="element-3246" data-mp="1ref0j0hcykfp" />
              <p className="text-gray-300 text-sm leading-relaxed flex-1" data-id="element-3247" data-mp="1rg87yhzsp8or">
                "Nunca había usado IA para negocios. Ahora la uso todos los días
                y ha transformado completamente mi forma de trabajar."
              </p>
              <div className="mt-4 pt-4 border-t border-gray-800" data-id="element-3248" data-mp="37rvmt6xl67uq">
                <p className="font-bold text-white text-sm" data-id="element-3249" data-mp="37u82fdfvg64m">Roberto S.</p>
                <p className="text-gray-500 text-xs" data-id="element-3250" data-mp="w48o6jz1ayrj">Doral, FL</p>
              </div>
            </div>
          </div>
        </section>

        {/* CLOSING NOTE */}
        <section className="text-center pb-4" data-id="element-3251" data-mp="megudryre9o4">
          <div className="inline-flex items-center gap-3 bg-[#00f7fc]/10 border border-[#00f7fc]/20 rounded-2xl px-6 py-4" data-id="element-3252" data-mp="md5mph270hrq">
            <CheckCircleIcon className="w-5 h-5 text-[#00f7fc] flex-shrink-0" data-id="element-3253" data-mp="cgswwu9rqo29" />
            <p className="text-gray-300 text-sm md:text-base" data-id="element-3254" data-mp="cepx5iitdgkc">
              Nos vemos en la llamada. Prepárate para tomar acción.
            </p>
          </div>
        </section>
      </main>

      <Footer data-id="element-3255" data-mp="3igy44yr0jyq" />
      <WhatsAppButton data-id="element-3256" data-mp="3umnql5uwzxjg" />
    </div>;
}